<template>
    <div>
        <v-dialog v-model="shownRelay" width="400">
            <v-card>
                <div class="primary white--text d-flex align-center">
                    <v-card-title class="py-1 my-1 flex-grow-1">
                        Download Options
                    </v-card-title>
                    <v-btn
                            class="mx-2"
                            icon
                            color="white"
                            @click="shownRelay = false"
                            dark
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div class="pa-2">
                    <div class="body-2 font-weight-bold pb-2">
                        Format
                    </div>
                    <div class="d-flex align-center pb-2">
                        <v-btn
                                color="primary"
                                :outlined="downloadFormat !== 'pdf'"
                                @click="downloadFormat = 'pdf'"
                                class="mx-2"
                        >
                            PDF
                        </v-btn>
                        <v-btn
                                color="primary"
                                :outlined="downloadFormat !== 'jpeg'"
                                @click="downloadFormat = 'jpeg'"
                                class="mx-2"
                        >
                            JPEG
                        </v-btn>
                    </div>
                    <div class="body-2 font-weight-bold pb-2 pt-2">
                        Filename <span class="caption grey--text">(NB* clock no only if captured)</span>
                    </div>
                    <div class="d-flex align-center pb-2">
                        <v-btn
                                color="primary"
                                :outlined="downloadFilename !== 'id'"
                                @click="downloadFilename = 'id'"
                                class="mx-2"
                        >
                            ID/Passport No
                        </v-btn>
                        <v-btn
                                color="primary"
                                :outlined="downloadFilename !== 'clock'"
                                @click="downloadFilename = 'clock'"
                                class="mx-2"
                        >
                            Clock No
                        </v-btn>
                    </div>
                    <div class="body-2 font-weight-bold pt-2">
                        Select Images <span class="caption grey--text">(NB* only captured images will download)</span>
                    </div>
                    <div class="pb-2">
                        <v-checkbox
                                v-model="downloadIdentity"
                                label="Identity Document"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadIdentityBack"
                                label="Identity Document Back"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadRecruitment"
                                label="Recruitment Form"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadPhoto"
                                label="Face Photo"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadClock"
                                label="Clock Card"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                        <v-checkbox
                                v-model="downloadBanking"
                                label="Proof of Banking"
                                hide-details
                                class="mt-0 pt-2 ml-2"
                        ></v-checkbox>
                    </div>
                </div>

                <div class="pa-2 d-flex justify-end">
                    <v-btn
                            color="grey"
                            text
                            @click="shownRelay = false"
                            :disabled="loading"
                            class="mx-2"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="downloadStart"
                            :loading="loading"
                            :disabled="loading"
                    >
                        Download
                    </v-btn>
                </div>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {format} from "date-fns";
import axios from "axios";
import {PDFDocument} from 'pdf-lib'
export default {
    props: {
        shown: Boolean,
        recruitment: Object,
        identityUrl: String,
        identityBackUrl: String,
        recruitmentUrl: String,
        photoUrl: String,
        clockUrl: String,
        bankingUrl: String,
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {

        async downloadImage(url, filename) {
            return this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url}, filename, true, false)
                    .catch(e => {
                        console.log(e)
                        this.$snack.error(`Error downloading ${filename}`)
                    })
        },

        async downloadStart() {
            const identificationStr = this.recruitment.idNo || this.recruitment.passportNumber
            const clockStr = this.recruitment.clockNo || identificationStr
            const downloadPrefix = (this.downloadFilename === 'clock' ? clockStr : identificationStr) || `Recruitment ${format(new Date(this.recruitment.captured), 'yyyy-MM-dd_HH_mm')}`
            if (this.downloadFormat === 'jpeg') {
                this.loading = true;
                const downloads = []
                if (this.identityUrl && this.downloadIdentity)
                    downloads.push(this.downloadImage(this.identityUrl, `${downloadPrefix} Identification.jpeg`));
                if (this.downloadIdentityBack && this.identityBackUrl)
                    downloads.push(this.downloadImage(this.identityBackUrl, `${downloadPrefix} Identification Back.jpeg`));
                if (this.downloadRecruitment && this.recruitmentUrl)
                    downloads.push(this.downloadImage(this.recruitmentUrl, `${downloadPrefix} Recruitment Form.jpeg`));
                if (this.downloadPhoto && this.photoUrl)
                    downloads.push(this.downloadImage(this.photoUrl, `${downloadPrefix}.jpeg`));
                if (this.downloadClock && this.clockUrl)
                    downloads.push(this.downloadImage(this.clockUrl, `${downloadPrefix} Clock Card.jpeg`));
                if (this.downloadBanking && this.bankingUrl)
                    downloads.push(this.downloadImage(this.bankingUrl, `${downloadPrefix} Proof of Banking.jpeg`));
                Promise.all(downloads)
                        .finally(() => {
                            this.loading = false;
                            this.shownRelay = false;
                        })
            } else {
                try {
                    this.loading = true
                    const downloads = [];
                    if (this.identityUrl && this.downloadIdentity)
                        downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: this.identityUrl}, `${downloadPrefix} Identification.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                    if (this.downloadIdentityBack && this.identityBackUrl)
                        downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: this.identityBackUrl}, `${downloadPrefix} Identification Back.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                    if (this.downloadRecruitment && this.recruitmentUrl)
                        downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: this.recruitmentUrl}, `${downloadPrefix} Recruitment Form.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                    if (this.downloadPhoto && this.photoUrl)
                        downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: this.photoUrl}, `${downloadPrefix} Face Photo.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                    if (this.downloadClock && this.clockUrl)
                        downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: this.clockUrl}, `${downloadPrefix} Clock Card.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                    if (this.downloadBanking && this.bankingUrl)
                        downloads.push(this.$newReqDownloadFile("POST", `recruitment/downloadImage`, {url: this.bankingUrl}, `${downloadPrefix} Proof of Banking.jpeg`, true, false, false, true).then(fetch).then((res) => res.arrayBuffer()));
                    const images = await Promise.all(downloads)

                    const pdfDoc = await PDFDocument.create()

                    for (const images of images) {
                        const jpgImage = await pdfDoc.embedJpg(images)
                        const scaleToFitRatio = 841.89/jpgImage.height
                        const jpgDims = jpgImage.scale(scaleToFitRatio)
                        const page = pdfDoc.addPage([jpgDims.width, jpgDims.height])
                        page.drawImage(jpgImage, {
                            x: 0,
                            y: 0,
                            width: jpgDims.width,
                            height: jpgDims.height,
                        })
                    }

                    const pdfBytes = await pdfDoc.save()
                    const url = window.URL.createObjectURL(new Blob([pdfBytes]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = "_blank"
                    link.setAttribute('download', `${downloadPrefix}.pdf`); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                } catch (e) {
                    console.log(e)
                    this.$snack.netWorkError()
                } finally {
                    this.loading = false
                    this.shownRelay = false;
                }
            }
        },
    },
    computed: {
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        },
        downloadFormat: {
            get() {return this.$store.state.downloadImageOptions.format},
            set(val) {this.$store.state.downloadImageOptions.format = val}
        },
        downloadFilename: {
            get() {return this.$store.state.downloadImageOptions.filename},
            set(val) {this.$store.state.downloadImageOptions.filename = val}
        },
        downloadIdentity: {
            get() {return this.$store.state.downloadImageOptions.identity},
            set(val) {this.$store.state.downloadImageOptions.identity = val}
        },
        downloadIdentityBack: {
            get() {return this.$store.state.downloadImageOptions.identityBack},
            set(val) {this.$store.state.downloadImageOptions.identityBack = val}
        },
        downloadRecruitment: {
            get() {return this.$store.state.downloadImageOptions.recruitment},
            set(val) {this.$store.state.downloadImageOptions.recruitment = val}
        },
        downloadPhoto: {
            get() {return this.$store.state.downloadImageOptions.photo},
            set(val) {this.$store.state.downloadImageOptions.photo = val}
        },
        downloadClock: {
            get() {return this.$store.state.downloadImageOptions.clock},
            set(val) {this.$store.state.downloadImageOptions.clock = val}
        },
        downloadBanking: {
            get() {return this.$store.state.downloadImageOptions.banking},
            set(val) {this.$store.state.downloadImageOptions.banking = val}
        },
    },
}
</script>

<style scoped>

</style>